import React from 'react'
import { InputMask } from "primereact/inputmask";

import InputWrapper from './InputWrapper';

// Utilities

import { setNestedFieldName, setNestedFieldError } from '../../../utilities/helper-functions';

import './Styles.scss';

export default function MaskInput(props) {
    const {
        formik,
        fieldName,
        isRequired,
        placeholder,
        additionalFunctions,
        mask,
        disabled
    } = props;

    const error = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.errors) : formik.errors[fieldName];
    const touched = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.touched) : formik.touched[fieldName];

    // function selectText() {
    //     const input = document.getElementById(fieldName);
    //     input.select();
    // }

    // const handleMaskFocus = (e) => {
    //     setTimeout(() => {
    //         e.target.setSelectionRange(0, 0);
    //     }, 0);
    // };

    return (
        <InputWrapper {...props}>

            <InputMask
                id={fieldName}
                name={fieldName}
                value={fieldName.includes('.') ? setNestedFieldName(fieldName, formik.values) : formik.values[fieldName]}
                // onChange={formik.handleChange(fieldName)}
                onChange={(e) => {
                    formik.setFieldValue(fieldName, e.target.value);
                    if (additionalFunctions) {
                        additionalFunctions()
                    }
                }}
                onBlur={formik.handleBlur(fieldName)}
                // onFocus={handleMaskFocus}
                placeholder={placeholder}
                mask={mask}
                className={`input-field ${error && touched ? 'p-invalid' : ''}`}
                required={isRequired}
                disabled={disabled}
                autoClear={false}
                unmask={true}
            // slotChar={''}
            />

        </InputWrapper>
    )
}

